import { environment } from 'src/environments/environment';
import { BaseUrlInterceptor } from './interceptor/base-url.interceptor';
import { SnackarInterceptor } from './interceptor/snackbar.interceptor';
import { AuthenticationInterceptor } from './interceptor/authentication.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';



@NgModule({
  declarations: [],
  imports: [
    HttpClientModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseUrlInterceptor, multi: true
    },
    {
      provide: 'BASE_API_URL',
      useValue: environment.apiUrl
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SnackarInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
